import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

function PrivateRoute({ children }) {
	const { user, loading } = useAuth();
	const location = useLocation();

	// Show loading indicator
	if (loading) {
		return <div className="loading-container">Loading...</div>;
	}

	// Redirect to login if not authenticated
	if (!user) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	// Render children if authenticated
	return children;
}

export default PrivateRoute;
